import { render, staticRenderFns } from "./team-container.vue?vue&type=template&id=1045aabe&scoped=true&"
import script from "./team-container.vue?vue&type=script&lang=ts&"
export * from "./team-container.vue?vue&type=script&lang=ts&"
import style0 from "./team-container.vue?vue&type=style&index=0&id=1045aabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045aabe",
  null
  
)

export default component.exports